import React from 'react';
import styled from 'styled-components';

const Icon = styled.img`
  width: 1rem;
  margin-right: 1rem;
  position: relative;
  z-index: 1;
`;

export default ({ type }) => <Icon src={`/images/shipment-status/${type}.svg`} />;
